import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { DealPipelineSummary, TimeRangeKey } from "@colab/shared";

// GET /api/portal/analytics/pipeline — KPI totals + by-stage chart in one
// response. The endpoint folds what would be two queries (KPIs and stage
// distribution) into a single Supabase pass; the hook surfaces the full
// summary so callers can slice .totals and .byStage independently.
export function useDealPipeline(range: TimeRangeKey) {
  return useQuery<DealPipelineSummary, ApiClientError>({
    queryKey: queryKeys.portal.analytics.pipeline(range),
    queryFn: () =>
      apiFetch<DealPipelineSummary>(
        `/portal/analytics/pipeline?range=${range}`,
      ),
  });
}
